'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowUp = void 0;
var $ = require("jquery");
require("slick-carousel");
var FollowUp = /** @class */ (function () {
    function FollowUp() {
        if ($('#pramFollowUp').length) {
            // Intersection Observer API
            var io = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting) {
                    // 見えたとき
                    $('.follow-up').fadeOut();
                }
                else {
                    // 見えないとき
                    $('.follow-up').fadeIn();
                }
            });
            var target = document.querySelector('#pramFollowUp'); // $('')だとエラーが出るため
            io.observe(target); // 監視開始
        }
    }
    return FollowUp;
}());
exports.FollowUp = FollowUp;
exports.default = FollowUp;
